<template>
  <div class="prospects">
    <ProspectsFilter
      @update="updateSettings($event)"
      @showAddDialog="addDialog = true"
    />
    <v-dialog v-if="addDialog" v-model="addDialog" width="1000">
      <ProspectAdd @close="addDialog = false" @added="reload()" />
    </v-dialog>
    <ProspectsView @update="reload()" :column="settings.column" />
  </div>
</template>

<script>
import { DEFAULT_PROSPECTS_FILTERS_SETTINGS } from "../data/DefaultSettings";
import ProspectAdd from "../components/ProspectAdd";
import ProspectsView from "../components/ProspectsView";
import ProspectsFilter from "../components/ProspectsFilter";
import { mapActions } from "vuex";

export default {
  name: "prospects",
  components: {
    ProspectAdd,
    ProspectsView,
    ProspectsFilter
  },
  data() {
    return {
      settings: DEFAULT_PROSPECTS_FILTERS_SETTINGS,
      addDialog: false
    };
  },
  beforeMount() {
    this.reload();
  },
  methods: {
    ...mapActions("prospects", ["resetProspects", "listProspects"]),
    updateSettings(settings) {
      this.settings = settings;
      this.listProspects({ filterSettings: this.settings });
    },
    async reload() {
      this.addDialog = false;
      await this.resetProspects("resetProspects");
      await this.listProspects({ filterSettings: this.settings });
    }
  }
};
</script>
